<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">下载中心</div>

      <!-- 表格 -->
      <div class="list-table">
        <el-table :data="tableData" :stripe="true" border>
          <el-table-column type="index" width="" align="center">
          </el-table-column>
          <el-table-column
            label="下载日期"
            prop="downDate"
            min-width="150"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="下载类型"
            prop="downTypeName"
            min-width="150"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="下载url"
            prop="downUrl"
            min-width="150"
            align="center"
          >
          <template slot-scope="scope">
            <!-- <a :href="'http://192.168.8.174:7999'+scope.row.downUrl">{{ scope.row.downUrl }}</a> -->
            <a :href="'http://ocharge.shzhida.com:6777'+scope.row.downUrl">{{ scope.row.downUrl }}</a>
             
          </template>
          </el-table-column>
          <el-table-column
            label="下载用户"
            prop="downUserName"
            min-width="150"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="下载用户手机号"
            prop="downUserPhone"
            min-width="150"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        ></ZD-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      pagination: pageConfig.pagination,
      tableData: [], //表格数据
      info: {}, //页码与搜索框
      operates: {
        width: 220,
        fixed: "right",
        list: [],
      }, // 列操作按钮
    };
  },
  computed: {},
  watch: {},
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //   获取表单详情
    init() {
      this.getListData(this.pagination);
    },
    //获取数据
    getListData(val) {
      this.info.pageNum = val.current - 1;
      this.info.pageSize = val.pageSize;
      this.info.corpNo = this.$store.state.corpNo;
      let _ = this;
      _.$U.showLoading(_);
      _.$H.post(_, _.$A.downloadCenter.page, _.info).then((res) => {
        _.tableData = res.data.data.content || [];
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },
    open(){

    }
  },
};
</script>

<style scoped lang="scss"></style>
